import { z } from "zod/v4";

// avoid that zod probes for eval support with "new Function"
// which a CSP without 'unsafe-eval' blocks and reports
z.config({ jitless: true });

export { z };
